/**
 * Select Dropdown for Category-Filter.
 */
import * as helper from './helper';

export default class Dropdown {
	constructor(el) {
		this.el = el;
		this.container = this.el.parentNode;
		this.type = el.dataset.type;
		this.clearBtn = document.querySelector('.em-content-category__filters--clear');
		this.options = this.el.querySelectorAll('.em-content-category__select--option');
		this.filterItems = document.querySelector('.em-content-category__filters--items');

		// Set checkboxes based on queryString data.
		this.savedTerms = helper.getQueryStringParam('terms', helper.getQueryString());
		this.addSavedTerms();

		this.el.querySelector('.em-content-category__select--title').addEventListener('click', this.handleDropdownClick);
		this.clearBtn.addEventListener('click', this.handleClearFiltersClick);
		document.addEventListener('click', this.handleDocumentClick);
		this.options.forEach((option) => {
			option.addEventListener('click', this.handleOptionClick);
		});
	}

	handleDropdownClick = (e) => {
		const { target } = e;
		const parent = target.closest('.em-content-category__select');
		if (parent.classList.contains('open')) {
			parent.classList.remove('open');
		} else {
			parent.classList.add('open');
		}
	}

	handleDocumentClick = (e) => {
		const checkLocation = e.target.closest(`[data-type="${this.type}"]`);
		if (checkLocation === null) {
			this.el.classList.remove('open');
		}
	}

	handleOptionClick = (e) => {
		const checkbox = e.target.closest('.em-content-category__select--option').querySelector('.em-content-category__select--checkbox');
		if (checkbox.classList.contains('checked')) {
			checkbox.classList.remove('checked');
		} else {
			checkbox.classList.add('checked');
		}
		this.updateFilterData();
	}

	handleClearFiltersClick = () => {
		this.container.querySelectorAll('.em-content-category__select--checkbox.checked').forEach((checkbox) => {
			checkbox.classList.remove('checked');
		});
		this.updateFilterData();
	}

	handleLabelFilterClick = (e) => {
		const { container } = this;
		const { target } = e;
		const { id } = target.dataset;
		const selectedCheckbox = container.querySelector(`[data-value="${id}"]`);
		selectedCheckbox.classList.remove('checked');

		// Call updateFilterData, which will remove the filter label.
		this.updateFilterData();
	}

	updateFilterData() {
		const ids = [];
		const labels = [];
		this.container.querySelectorAll('.em-content-category__select--checkbox.checked').forEach((checkbox) => {
			ids.push(checkbox.dataset.value);
			labels.push(checkbox.dataset.label);
		});
		this.container.setAttribute('data-select-filters', ids);
		this.addFilterLabels(labels, ids);

		// Set query strings if not intial page load.
		if (typeof this.container.dataset.saved === 'undefined') {
			helper.setQueryString(ids);
		} else {
			this.container.removeAttribute('data-saved');
		}

		// Handle the display of the filters section.
		if (ids.length) {
			this.clearBtn.parentNode.style.display = 'flex';
		} else {
			this.clearBtn.parentNode.style.display = 'none';
		}
	}

	addFilterLabels(labels, ids) {
		const { filterItems } = this;
		let filterHTML = '';
		labels.forEach((label, index) => {
			filterHTML += `<span data-label="${label}" data-id="${ids[index]}">${label}</span>`;
		});
		filterItems.innerHTML = filterHTML;
		filterItems.childNodes.forEach((filterItemLabel) => {
			filterItemLabel.addEventListener('click', this.handleLabelFilterClick);
		});
	}

	/**
	 * Handles auto populating filter set based on queryString parameter.
	 */
	addSavedTerms() {
		const { savedTerms, container } = this;
		const queryStringSaved = container.dataset.saved;
		if (savedTerms.length && (typeof queryStringSaved === 'undefined')) {
			container.setAttribute('data-saved', 'true'); // Flag to prevent looping over saved items.
			container.querySelectorAll('.em-content-category__select--checkbox').forEach((checkbox) => {
				if (!checkbox.classList.contains('checked')) {
					const { value } = checkbox.dataset;
					if (savedTerms.indexOf(value) !== -1) {
						checkbox.classList.add('checked');
					}
				}
			});
			this.updateFilterData();
		}
	}
}
